export default __webpack_public_path__ + "static/media/nave.a3cedbe2.svg";